
import Vue from 'vue'

import TargetTypes from './TargetTypes.vue'
import Action from './Action.vue'
import Status from './Status.vue'
import Roles from './Roles.vue'

export default Vue.extend({
   name: 'DataTableCell',
   props: {
      row: Object,
      column: Object as () => IDataTableColumn,
   },
   components: { TargetTypes, Status, Action, Roles },
})
